import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Heading, Spinner } from "../../../../widgets";
import { HeadingProperties, useHeadingProperties } from "./HeadingProperties";

import { DraftHeadingComponent } from "./DraftHeadingComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

interface IHeadingComponentProps extends IControlAttributes {
    as: React.ElementType
}

export const HeadingComponent: FC<IHeadingComponentProps> = ({
    as: AsComponent, control, children, designerMode, props, className, ...rest
}) => {
    const { status, properties, error } = useHeadingProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Heading
        as={AsComponent}
        {...properties}
        className={className}
        iconClassName="me-1"
    >
        {children}
    </Heading>
}

const H1: FC<IControlAttributes> = (props) => <HeadingComponent as="h1" {...props} />
const DraftH1: FC<IControlAttributes> = (props) => <DraftHeadingComponent as="h1" {...props} />
const H2: FC<IControlAttributes> = (props) => <HeadingComponent as="h2" {...props} />
const DraftH2: FC<IControlAttributes> = (props) => <DraftHeadingComponent as="h2" {...props} />
const H3: FC<IControlAttributes> = (props) => <HeadingComponent as="h3" {...props} />
const DraftH3: FC<IControlAttributes> = (props) => <DraftHeadingComponent as="h3" {...props} />
const H4: FC<IControlAttributes> = (props) => <HeadingComponent as="h4" {...props} />
const DraftH4: FC<IControlAttributes> = (props) => <DraftHeadingComponent as="h4" {...props} />
const H5: FC<IControlAttributes> = (props) => <HeadingComponent as="h5" {...props} />
const DraftH5: FC<IControlAttributes> = (props) => <DraftHeadingComponent as="h5" {...props} />
const H6: FC<IControlAttributes> = (props) => <HeadingComponent as="h6" {...props} />
const DraftH6: FC<IControlAttributes> = (props) => <DraftHeadingComponent as="h6" {...props} />

Registry.addControl({
    id: "93a4d18e-78f6-410e-a64a-4fa94657ca2c",
    name: "Heading 1",
    type: ControlType.Heading1,
    properties: HeadingProperties,
    component: H1,
    draftComponent: DraftH1
})

Registry.addControl({
    id: "93582524-4f28-4af6-9eb4-5e282caee8dd",
    name: "Heading 2",
    type: ControlType.Heading2,
    properties: HeadingProperties,
    component: H2,
    draftComponent: DraftH2
})

Registry.addControl({
    id: "fa04369e-a3cb-4123-ac1d-ae178394b196",
    name: "Heading 3",
    type: ControlType.Heading3,
    properties: HeadingProperties,
    component: H3,
    draftComponent: DraftH3
})

Registry.addControl({
    id: "5de167c5-4389-41a6-ac58-cda55efc304b",
    name: "Heading 4",
    type: ControlType.Heading4,
    properties: HeadingProperties,
    component: H4,
    draftComponent: DraftH4
})

Registry.addControl({
    id: "bdb9c562-6501-4925-a4ce-820f67dc23f4",
    name: "Heading 5",
    type: ControlType.Heading5,
    properties: HeadingProperties,
    component: H5,
    draftComponent: DraftH5
})

Registry.addControl({
    id: "795a4d58-bfa8-4e7f-847f-81b64e568393",
    name: "Heading 6",
    type: ControlType.Heading6,
    properties: HeadingProperties,
    component: H6,
    draftComponent: DraftH6
})
